import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { openTab } from "../redux/actions/workspaceActions";
import { SIDEBAR_ITEMS } from "../config/sidebarConfig";
import { STANDALONE_ROUTES } from "../config/standAlonePagesRoutes";

const useRouteToWorkspaceSync = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { tabs } = useSelector((state) => state.workspace);

  useEffect(() => {
    // 1. Force route to /dashboard if we are at the root
    let currentPath = location.pathname;
    if (currentPath === "/" || currentPath === "") {
      currentPath = "/dashboard";
      navigate(currentPath, { replace: true });
    }

    if (STANDALONE_ROUTES.some((route) => currentPath.startsWith(route))) {
      return;
    }

    // 2. If no tabs are open (e.g., just logged in or hard refresh)
    if (tabs.length === 0) {
      // Find the corresponding item in the sidebar
      const item = SIDEBAR_ITEMS.find((i) => i.path === currentPath);

      if (item && item.componentKey) {
        dispatch(
          openTab({
            id: item.path,
            title: item.title,
            path: item.path,
            componentKey: item.componentKey,
          }),
        );
      } else if (
        currentPath.startsWith("/receipts/") &&
        currentPath.split("/").length === 3
      ) {
        const id = currentPath.split("/").pop();
        const shortId = id.substring(0, 8);
        dispatch(
          openTab({
            id: currentPath,
            title: `Receipt #${shortId}...`,
            path: currentPath,
            componentKey: "RECEIPT",
          }),
        );
      } else if (
        currentPath.startsWith("/invoices/") &&
        currentPath.split("/").length === 3
      ) {
        const id = currentPath.split("/").pop();
        const shortId = id.substring(0, 8);
        dispatch(
          openTab({
            id: currentPath,
            title: `Invoice #${shortId}...`,
            path: currentPath,
            componentKey: "INVOICE",
          }),
        );
      } else if (
        currentPath.startsWith("/fiscal/invoices/") &&
        currentPath.split("/").length === 4
      ) {
        const id = currentPath.split("/").pop();
        const shortId = id.substring(0, 8);
        dispatch(
          openTab({
            id: currentPath,
            title: `Fiscal Invoice #${shortId}...`,
            path: currentPath,
            componentKey: "FISCAL_INVOICE",
          }),
        );
      } else if (
        currentPath.startsWith("/credit-notes/") &&
        currentPath.split("/").length === 3
      ) {
        const id = currentPath.split("/").pop();
        const shortId = id.substring(0, 8);
        dispatch(
          openTab({
            id: currentPath,
            title: `C.Note #${shortId}...`,
            path: currentPath,
            componentKey: "CREDIT_NOTE",
          }),
        );
      } else if (currentPath === "/dashboard") {
        // Failsafe: Guarantee the dashboard opens even if config is temporarily mismatched
        dispatch(
          openTab({
            id: "/dashboard",
            title: "Dashboard",
            path: "/dashboard",
            componentKey: "DASHBOARD",
          }),
        );
      }
    }
  }, [location.pathname, tabs.length, dispatch, navigate]);
};

export default useRouteToWorkspaceSync;
